import 'intersection-observer';
import * as React from "react";
import { InView } from 'react-intersection-observer';
import { IOWidget, Updater, fromJSX } from "widgets-for-react";
import { blockInviewHandler } from "../../../drupal/rendering/inview_utils.mod";
import { CMSState } from '../../../publicSite/drupalPage/state'
import { getClassName, link } from "../utils.gen";

export type LinkBlockProps = {
  index: number
  title: React.ReactNode
  intro?: string
  items: LinkProps[]
  useSVGIcons: boolean
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type LinkProps = {
  key?: string
  title: string
  url: string
  text?: string
  is_link_external: boolean
  target?: "_blank" | "_self"
}

export type LinkBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  intro_classname: string
  content_classname: string
  list_classname: string
  item_classname: string
  link_classname: string
  link_label_classname: string
  link_text_classname: string
  link_icon_classname: string
  icon_external_id: string
  icon_internal_id: string
}>

export function LinkBlock (
  props: LinkBlockProps,
  options?: {
    style?: LinkBlockStyle
    key?: string
  }
): IOWidget<CMSState , Updater<CMSState>> {
  return (s: CMSState ) =>
    fromJSX(
      _ => (
        <InView
          as="section"
          onChange={(inView) => blockInviewHandler('link', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
          triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
          threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
          id={`io-${options && options.key ? options.key : props.index}`}
          className={getClassName(options, "block_classname", "container")}
          key={options && options.key ? options.key : `block-${props.index}`}
        >
          <div className={getClassName(options, "inner_classname", "py-5")}>
            {(props.title || props.intro) && (
              <header className={getClassName(options, "header_classname", "")}>
                {props.title && (<h2 className={getClassName(options, "title_classname", "mb-3")}>{props.title}</h2>)}
                {props.intro && (<p className={getClassName(options, "intro_classname", "")}>{props.intro}</p>)}
              </header>
            )}

            <div className={getClassName(options, "content_classname", "")}>
              <ul className={getClassName(options, "list_classname", "list-unstyled mb-0 row")}>
                {props.items.map((l, index) => (
                  l.title && l.url && (
                    <li className={getClassName(options, "item_classname", "col-md-6")} key={`link-${options && options.key ? options.key : props.index}-${index}`}>
                      {link(
                        {
                          kind: "link", 
                          title: l.title,
                          url:l.url,
                          is_link_external: l.is_link_external,
                          target: l.target == undefined ?  "_self" : l.target
                        },
                        {
                          classname: getClassName(options, "link_classname", "btn btn-link w-100 text-left border-bottom rounded-0 pl-0")
                        },
                        (<>
                          <span className={getClassName(options, "link_label_classname", "d-block")}>{l.title}</span>
                          {l.text && (<p className={getClassName(options, "link_text_classname", "small m-0")}>{l.text}</p>)}
                          {props.useSVGIcons && (
                            <svg className={getClassName(options, "link_icon_classname", "")} aria-hidden="true">
                              <use xlinkHref={`${l.is_link_external ? getClassName(options, "icon_external_id", "#icon--external") : getClassName(options, "icon_internal_id", "#icon--chevron-right-large")}`}/>
                            </svg>
                          )}
                        </>)
                      )}
                    </li>
                  )
                ))}
              </ul>
            </div>
          </div>
        </InView>
      ),
    )
}
